var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"alertAddCart"},[_c('div',{staticClass:"contain"},[_c('img',{staticClass:"checkMarkIcon",attrs:{"src":require("@/assets/img/checked.svg"),"alt":""}}),_c('div',[_vm._v("เพิ่มสินค้าแล้ว")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }